import { INDICATION_SET, INDICATION_DELETE } from '../actions/indication';

import { omit } from 'lodash';

const isLoading = {
  isLoading: {
    check: function isBlockingIndicator(actionType) {
      return this[actionType] && this[actionType].some(message => message.blocking === true);
    }
  }
};

/**
 * Уведомления для асинхронных событий
 * @param {Object} state  текущее состояние нотификаций
 * @param {Object} action происходящее действие
 * @return {Object} Обновленный не мутированный state
 */
function Indication(state = isLoading, action) {
  switch (action.type) {
    case INDICATION_SET:
      return {
        isLoading: {
          ...state.isLoading,
          ...action.payload
        }
      };
    case INDICATION_DELETE:
      return {
        isLoading: omit(state.isLoading, action.payload)
      };
    default:
      return state;
  }
}

export default Indication;
